import api from 'api';

export const uploadDPA = api('POST /api/business-partners/dpa/upload');
export const uploadNDA = api('POST /api/business-partners/nda/upload');
